import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type PlaceDetails } from 'GooglePlaces';
import { type FilterState, type FilterTab } from './hooks/usePeopleFilters.types';

export const INITIAL_FILTER_STATE: FilterState = {
    keywordSearch: '',
    activeTab: 'all',
    showAdvanced: false,
    places: [],
    programTypes: [],
    companies: [],
    industries: [],
    interests: [],
    lookingFor: [],
    timezones: [],
    userIds: [],
};

export const peopleFiltersSlice = createSlice({
    name: 'peopleFilters',
    initialState: INITIAL_FILTER_STATE,
    reducers: {
        setKeywordSearch(state, action: PayloadAction<string>) {
            state.keywordSearch = action.payload;
        },
        setActiveTab(state, action: PayloadAction<FilterTab>) {
            state.activeTab = action.payload;
        },
        setShowAdvanced(state, action: PayloadAction<boolean>) {
            state.showAdvanced = action.payload;
        },
        setPlaces(state, action: PayloadAction<PlaceDetails[]>) {
            state.places = action.payload;
        },
        setProgramTypes(state, action: PayloadAction<string[]>) {
            state.programTypes = action.payload;
        },
        setCompanies(state, action: PayloadAction<string[]>) {
            state.companies = action.payload;
        },
        setIndustries(state, action: PayloadAction<string[]>) {
            state.industries = action.payload;
        },
        setInterests(state, action: PayloadAction<string[]>) {
            state.interests = action.payload;
        },
        setLookingFor(state, action: PayloadAction<string[]>) {
            state.lookingFor = action.payload;
        },
        setTimezones(state, action: PayloadAction<string[]>) {
            state.timezones = action.payload;
        },
        setUserIds(state, action: PayloadAction<string[]>) {
            state.userIds = action.payload;
        },
        resetFilters(state) {
            Object.assign(state, INITIAL_FILTER_STATE);
        },
    },
});

export const { actions: peopleFiltersActions } = peopleFiltersSlice;
